// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"288":"8ea541167a6d2a7cff81","296":"249584bf5648727fc565","918":"97d08b899c72b395acf2","952":"5fa330fdc0695fc23267"}[chunkId] + ".js";
};